import React from "react";

const defaultImagePath = "/assets/marketing-site/images";

const CareTeamMap = ({ imagePath = defaultImagePath }) => (
	<div
		className="care-team-map"
		aria-label="The client and live-in carer are supported by a Care Manager, Care Coordinator and Edyn technology"
	>
		<div className="care-team-map__partnership">
			<img
				src={`${imagePath}/livein-imageclus-03.jpg`}
				alt="An older man sharing a conversation with his live-in carer at home"
				loading="lazy"
			/>
			<div className="care-team-map__partnership-note">
				<span aria-hidden="true">+</span>
				<p>
					<strong>Client + live-in carer</strong>
					<small>Care at home, working together every day</small>
				</p>
			</div>
		</div>
		<div className="care-team-map__support">
			<article>
				<img
					src={`${imagePath}/team/orianne.png`}
					alt="Edyn Care Manager"
					loading="lazy"
				/>
				<p>
					<strong>Care Manager</strong>
					<span>Care-plan reviews and quality oversight</span>
				</p>
			</article>
			<article>
				<img
					src={`${imagePath}/team/sarah.png`}
					alt="Edyn Care Coordinator"
					loading="lazy"
				/>
				<p>
					<strong>Care Coordinator</strong>
					<span>Day-to-day planning and continuity</span>
				</p>
			</article>
			<article className="care-team-map__technology">
				<span className="care-team-map__technology-icon">
					<img
						src={`${imagePath}/technology.png`}
						alt="Edyn care technology"
						loading="lazy"
					/>
				</span>
				<p>
					<strong>Edyn technology</strong>
					<span>Live updates and family visibility</span>
				</p>
			</article>
		</div>
		<p className="care-team-map__summary">
			<strong>One shared care plan.</strong>
			<span>People and technology staying connected around the home.</span>
		</p>
	</div>
);

export default CareTeamMap;
